<template>
  <div class="kpt-feedback-context-pane">
    <header class="kpt-context-pane-header">
      <h4><strong>Notifications</strong></h4>
      <b-icon class="is-clickable" icon="times-circle" @click.native="close"></b-icon>
    </header>
    <main class="kpt-context-pane-main">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p v-if="notifications.length">Total: {{notifications.length}} notification{{notifications.length > 1 ? 's' : ''}}</p>
            <p v-else>No notifications to show</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a @click="dismissAll">Dismiss all</a>
          </div>
        </div>
      </div>
      <hr>
      <notification-item v-for="(item, idx) in notifications" :key="idx" :item="item"></notification-item>
    </main>
    <footer class="kpt-context-pane-footer"></footer>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import NotificationItem from './NotificationItem.vue';

export default {
  components: {
    NotificationItem
  },
  props: {
    close: Function
  },
  async mounted() {
    await this.$store.dispatch('fetchNotifications');
    await this.$store.dispatch('markAllAsRead');
  },
  methods: {
    async dismissAll() {
      await this.$store.dispatch('clearNotifications');
    }
  },
  computed: {
    notifications() {
      return orderBy(this.$store.state.system.notifications.notifications, ['createdOnUnixMs'], ['desc'])
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-feedback-context-pane {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 425px;

  .kpt-feedback-icons {
    .feedback-icon {
      margin-right: 8px;
    }
  }
}
</style>
